// extracted by mini-css-extract-plugin
export default {"navMenu":"_2kIkd","menuItemWrapper":"_1K7B2"};